import React, { useEffect, useRef, useState } from "react";
import BookPreview from "./BookPreview";
import styled from "styled-components";
import { BackSvg } from "../images/Svg";
import Button from "../common/Button";
import wand from "../images/wand.svg";
import { useLocation } from "react-router";

const WrapperStyled = styled.div`
    margin: 2% auto;
    width: 80%;
`;

const BackWrapperStyled = styled.div`
    margin: 5px 0 10px;

    align-items: center;
    background: #ffa927;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: grid;
    height: 39px;
    justify-content: center;
    left: 149px;
    width: 39px;
    z-index: 1;

    svg {
        transform: rotate(180deg);
        cursor: pointer;
    }

    &.lang-en, &.lang-da {
        svg {
            transform: none;
        }
    }
`;

const ButtonWrapperStyled = styled.div`
    margin-top: 30px;
`;

const SingleBookPreview = ({ item, lang, langData, selecteBook, config, disableBackButton }) => {
    const wrapperRef = useRef(null);

    const location = useLocation();
    const queryParameters = new URLSearchParams(location.search);
    const clientId = queryParameters.get("clientId") || "64d491633684ef0d32edb473";

    const [width, s_width] = useState(600);

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            s_width(screenWidth < 600 ? screenWidth - 80 : 600);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (wrapperRef?.current) {
            s_width(wrapperRef.current.offsetWidth);
        }
    }, [wrapperRef]);

    let imageUrl = item?.imageUrl;
    if (imageUrl) {
        imageUrl = imageUrl + "?width=450";
    }

    let style = { backgroundImage: `linear-gradient(to left, rgb(60, 13, 20) 2px, rgba(255, 255, 255, 0.5) 4px, rgba(255, 255, 255, 0.25) 6px, rgba(255, 255, 255, 0.25) 4px, transparent 8px, transparent 6px, rgba(255, 255, 255, 0.25) 10px, transparent 12px), url(${ imageUrl })` };
    const textStyle = {};
    if (lang === "en") {
        style = { backgroundImage: `linear-gradient(to left, rgb(60, 13, 20) 2px, rgba(255, 255, 255, 0.5) 4px, rgba(255, 255, 255, 0.25) 6px, rgba(255, 255, 255, 0.25) 4px, transparent 8px, transparent 6px, rgba(255, 255, 255, 0.25) 10px, transparent 12px), url(${ imageUrl })` };
    }

    if (width / 2 < 200) {
        style.width = width / 2;
        style.height = width / 2;
        textStyle.width = width / 2;
    }
    const title = item.title;

    const book = [];
    let selectedBookCoverImage = null;
    let coverDesign = null;
    if (item.book) {
        coverDesign = item.book.template.coverDesign;
        item.book.approvedData.forEach(pp => {
            if (pp.pageIndex !== -1) {
                book.push({ img: pp.selectedImageUrl });
                book.push({ text: pp.text });
            } else {
                selectedBookCoverImage = pp.selectedImageUrl;
            }
        });
    }

    return (
        <WrapperStyled
            className={ `single-book-preview lang-${ lang }` }
            ref={ wrapperRef }>

            {!disableBackButton && (
                <BackWrapperStyled
                    className={ `lang-${ lang }` }
                    onClick={ selecteBook }>
                    {/*<Back2Icon/>*/ }
                    <BackSvg />
                </BackWrapperStyled>
            )}


            <BookPreview
                width={ width }
                bookCoverData={
                    {
                        img: selectedBookCoverImage,
                        text: title,
                        coverDesign
                    }
                }
                lang={ lang }
                langData={ langData }
                book={ book }
            />
            <ButtonWrapperStyled>
                <Button
                    onClick={ () => {
                        let frameUrl = "https://app.mebook.ai";
                        if (config?.domain) {
                            frameUrl = `https://app.${ config.domain }`;
                        }

                        // if (config.editorUrlTemplate && config.appBaseUrl) {
                        //     const baseEditorUrl = config.editorUrlTemplate
                        //         .replaceAll("{{appBaseUrl}}", config.appBaseUrl)
                        //         .replaceAll("editor/preview", "")
                        //         .replaceAll("{{language}}", lang);

                        //     const params = `templateId=${ item._id }&clientId=${ clientId }&language=${ lang }`;
                        //     frameUrl = `${ baseEditorUrl }?${ params }`;
                        //     window.open(`${ frameUrl }`, "_blank");
                        //     return;
                        // }

                        let relevantLink = `${frameUrl}?clientId=${clientId}&language=${lang}&templateId=${item._id}`;
                        relevantLink = `https://fun.mebook.ai/${lang}/start?templateId=${item._id}`;

                        // window.open(`${ frameUrl }?clientId=${ clientId }&language=${ lang }&templateId=${ item._id }`, "_blank");
                        window.open(relevantLink, "_blank");

                    } }
                    className="personalise_btn next-button">
                    { langData.i_want_this_template }
                    <img className="wand-icon" src={ wand } alt="wand" />
                </Button>
            </ButtonWrapperStyled>
        </WrapperStyled>
    );
};

export default SingleBookPreview;
